import React, { useState, useEffect } from 'react';
import apiService from '../../../services/apiService';
import CustomToast from '../../Toast';
import { useParams } from 'react-router-dom';
import Modal from 'react-modal';
import { useDropzone } from 'react-dropzone';
import Loader from '../../layouts/loader';
 
const DocumentUploadCenter = () => {
    const [complianceDocData, setComplianceDocData] = useState([]);
    const [complianceAllDocData, setComplianceAllDocData] = useState([]);
    const [compliancePercentage, setCompliancePercentage] = useState([]);
    const [loader, setLoader] = useState(true);
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);
    const { id } = useParams();
    const [complianceData, setComplianceData] = useState([]);
    const [currentDocType, setCurrentDocType] = useState('');
    const [complianceTitle, setComplianceTitle] = useState('');
    const [complianceId, setComplianceId] = useState('');
    const [title, setTitle] = useState('');
    const [category, setCategory] = useState('policy');
 
 
    let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));
 
    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        fetchComplianceDocData();
        handleCompliancePercentage();
        handleDownloadUploadDocument();
    }, []);
 
    const fetchComplianceDocData = async () => {
        setLoader(true);
        const token = apiService.getAuthToken();
        try {
            const response = await apiService.get(
                `get-compliances-document?org_id=${orgInfo?.org_id}`,
                token
            );
            if (response && response.status === 'success') {
                setComplianceDocData(response.data);
                setLoader(false);
            } else {
                CustomToast.error("Failed to fetch compliance data");
            }
            setLoader(false);
 
            // console.log("ComplianceDocData", complianceDocData)
        } catch (error) {
            CustomToast.error("Error fetching compliance data");
        }
    };
 
    const handleDeleteDoc = async (complianceId, docType, doc) => {
        const data = {
            org_id: orgInfo.org_id,
            compliance_id: complianceId,
            doc_type: docType,
            upload_url_id: doc.upload_url_id,
        };
 
        const token = apiService.getAuthToken();
        try {
            await apiService.delete(`/delete-compliances-document`, data, token);
            CustomToast.success("Document deleted");
            fetchComplianceDocData();
        } catch (error) {
            CustomToast.error("Failed to delete document");
        }
    };
 
    const handleDownloadUploadDocument = async () => {
        const token = apiService.getAuthToken();
        try {
            const response = await apiService.get(`download-upload-document/${orgInfo?.org_id}`, token);
            setComplianceAllDocData(response?.data);
 
            console.log("ComplianceAllDocData", complianceAllDocData, response)
        } catch (error) {
            CustomToast.error("Error fetching compliance document data");
        }
    };

    const handleCompliancePercentage = async () => {
        const token = apiService.getAuthToken();
        try {
            const response = await apiService.get(`compliance-percentage/${orgInfo?.org_id}`, token);
            setCompliancePercentage(response?.data);

            console.log("CompliancePercentage", response?.data)
        } catch (error) {
            CustomToast.error("Error fetching compliance percentage data");
        }
    };
 
    const openVideoModal = (complianceId, complianceTitle, title, docType) => {
        setCurrentDocType(docType);
        setComplianceTitle(complianceTitle);
        setComplianceId(complianceId);
        setTitle(title);
        console.log("ComplianceId : ", complianceId, "ComplianceTitle : ", complianceTitle, "Title : ", title, "DocType : ", docType);
        setModalOpen(true);
    };
 
    const closeVideoModal = () => {
        setModalOpen(false);
    };
 
    const onDrop = async (acceptedFiles) => {
        const maxFileSize = 10 * 1024 * 1024; // 10MB
 
        // Filter out oversized files
        const validFiles = acceptedFiles.filter(file => file.size <= maxFileSize);
 
        if (validFiles.length > 0) {
            setSelectedFiles(validFiles); // use a plural variable
            const previewUrls = await Promise.all(
                validFiles.map(file => {
                    return new Promise(resolve => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(file);
                    });
                })
            );
            setPreviewUrls(previewUrls); // array of base64 previews
        } else {
            setSelectedFiles([]);
            setPreviewUrls([]);
            CustomToast.error('Please choose valid files (each max size: 10MB).');
        }
    };
 
    const { fileRejections, getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
          'application/pdf': ['.pdf'],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
          'application/msword': ['.doc'],
          'application/images': ['.png', '.jpg', '.jpeg'],
        }
    });
 
    const handleUploadDocument = async () => {
        setLoader(true);
        if (!selectedFiles || selectedFiles.length === 0) {
            CustomToast.error('Please select at least one file to upload.');
            setLoader(false);
            return;
        }
 
        const compliance = complianceAllDocData[0];
 
        const formData = new FormData();
        formData.append('org_id', orgInfo?.org_id);
        formData.append('compliance_id', complianceId);
        formData.append('compliance_title', complianceTitle);
        formData.append('title', title);
        formData.append('doc_type', currentDocType);
 
        selectedFiles.forEach(file => {
            formData.append('files', file, file.name);
        });
 
        try {
            const token = apiService.getAuthToken();
            const response = await apiService.postFormdata('submit-compliances-document', formData, token);
 
            if (response && response.status === 'success') {
                CustomToast.success('Files uploaded successfully.');
                closeVideoModal();
                setSelectedFiles([]);
                setPreviewUrls([]);
                setLoader(false);
                setTimeout(() => {
                    window.location.reload(true);
                }, 1000);
            } else {
                CustomToast.error('Error uploading files.');
                setLoader(false);
            }
        } catch (error) {
            console.error(error);
            CustomToast.error('Error uploading files.');
            setLoader(false);
        }
    };
 
    return (
        <div className='page__main'>
            <div className="dashboard" style={{ minHeight: '100vh' }}>
 
                <div className="container-fluid compliance-checklist">
 
                    <div className="row mb-4">
                        <h4 className='text-black font-weight-600 px-0'>Compliance &gt; Document Upload Center</h4>
                        <p className='font-16 px-0'>Maintain and share your POSH policy effectively to keep your workplace safe and compliant.</p>
                    </div>
                    <div className="row">
                        <div className="card ">
                            <div className="card-header border-bottom bg-white d-flex justify-content-between align-items-center py-4">
                                <h5 className="text-black font-weight-600 mb-0">Document Upload Center</h5>
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={handleDownloadUploadDocument}
                                    style={{ color: '#146EF6', textDecoration: 'none', pointerEvents: complianceAllDocData && complianceAllDocData.length > 0 ? 'auto' : 'none', opacity: complianceAllDocData && complianceAllDocData.length > 0 ? 1 : 0.5 }}
                                >
                                    <img src="/images/download-icon.svg" alt="Download all" />  <span style={{ color: '#146EF6', textDecoration: 'underline' }}>Download all</span>
                                </button>
                            </div>
 
                            {loader ? <Loader /> :
                                <>
                                    {(() => {
                                        // Define the desired sequence and create all compliance categories
                                        const allComplianceCategories = [
                                            { title: "POSH Policy", category: "policy", templateTitle: "Download policy template from the" },
                                            { title: "Visibility & Posters", category: "poster", templateTitle: "Download poster template from the" },
                                            { title: "Internal Committee", category: "ic_template", templateTitle: "Download IC composition and registration formats from the" },
                                            { title: "Training & Awareness", category: "email_campaign", templateTitle: "Download training & awareness template from the" },
                                            { title: "Documentation", category: "annual_report", templateTitle: "Download annual report templates from our" }
                                        ];

                                        return allComplianceCategories.map((complianceCategory, index) => {
                                            // Find existing compliance data for this category
                                            const existingCompliance = complianceDocData.find(
                                                compliance => compliance.compliance_title === complianceCategory.title
                                            );

                                            // Helper function to get percentage for this compliance category
                                            const getCompliancePercentage = (categoryTitle) => {
                                                const titleMapping = {
                                                    "POSH Policy": "PoSH Policy & Dissemination",
                                                    "Visibility & Posters": "Visibility & Posters",
                                                    "Internal Committee": "Internal Committee (IC): Constitution and Registration",
                                                    "Training & Awareness": "Training & Capacity Building",
                                                    "Documentation": "Report & Documentation"
                                                };
                                                
                                                const apiTitle = titleMapping[categoryTitle];
                                                const complianceData = Array.isArray(compliancePercentage) 
                                                    ? compliancePercentage.find(cp => cp?.complianceTitle === apiTitle)
                                                    : null;
                                                
                                                if (complianceData) {
                                                    // Calculate percentage based only on selectedCount and totalOptions
                                                    const selectedCount = complianceData.selectedCount || 0;
                                                    const totalOptions = complianceData.totalOptions || 0;
                                                    
                                                    if (totalOptions === 0) {
                                                        return 0;
                                                    }
                                                    
                                                    // Calculate percentage: (selectedCount / totalOptions) * 100
                                                    const calculatedPercentage = Math.round((selectedCount / totalOptions) * 100);
                                                    return Math.min(calculatedPercentage, 100); // Cap at 100%
                                                }
                                                
                                                return 0;
                                            };

                                            const percentageValue = getCompliancePercentage(complianceCategory.title);

                                            // If no data exists for this category, show empty state
                                            if (!existingCompliance || existingCompliance.uploadDocument.length === 0) {
                                                return (
                                                    <div className="px-3 py-4 border-bottom" key={index}>
                                                        <div className="card-header border d-flex justify-content-between align-items-center" style={{ background: '#EFEFEF' }}>
                                                            <strong>{complianceCategory.title === "Training & Awareness" ? "Training & Capacity Building" : complianceCategory.title}</strong>
                                                            <div className="d-flex align-items-center">
                                                                <div className="me-2 text-muted fw-bold">
                                                                    <div className="position-relative" style={{ width: 40, height: 40 }}>
                                                                        <svg viewBox="0 0 36 36" className="circular-chart" style={{ width: 40, height: 40 }}>
                                                                            <path
                                                                                className="circle-bg"
                                                                                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                                                                fill="none"
                                                                                stroke="#eee"
                                                                                strokeWidth="3"
                                                                            />
                                                                            <path
                                                                                className="circle"
                                                                                strokeDasharray={`${percentageValue}, 100`}
                                                                                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                                                                fill="none"
                                                                                stroke={percentageValue > 0 ? "#23A298" : "#d6d6d6"}
                                                                                strokeWidth="3"
                                                                            />
                                                                        </svg>
                                                                        <span className="position-absolute top-50 start-50 translate-middle" style={{ fontSize: "0.65rem" }}>
                                                                            {percentageValue}%
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <span className="fw-semibold text-decoration-underline">Completed</span>
                                                            </div>
                                                        </div>
                                                        <div className="px-3 py-4 text-center text-muted">
                                                            <p className="mb-0">No documents are uploaded.</p>
                                                        </div>
                                                        <p className="mt-4 mb-0 mx-4 text-muted small">
                                                            {complianceCategory?.templateTitle}{" "}
                                                            <a
                                                                href={`/template_library/${complianceCategory?.category}`}
                                                                className="text-primary text-decoration-underline"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Template Library <img src="/images/arrow-icon.svg" alt="External Link" className='ms-1' width="10" />
                                                            </a>
                                                        </p>
                                                    </div>
                                                );
                                            }

                                            // If data exists, render normally
                                            const compliance = existingCompliance;
                                            
                                            // Use the same percentage calculation as above
                                            const compliancePercent = percentageValue;
                                            
                                            const groupedByTitle = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                                                if (!acc[uploadDoc.title]) {
                                                    acc[uploadDoc.title] = [];
                                                }
                                                acc[uploadDoc.title].push(uploadDoc);
                                                return acc;
                                            }, {});

                                            return (
                                                <div className="px-3 py-4 border-bottom" key={index}>

                                                    {Object.entries(groupedByTitle).map(([title, uploadDocs], groupIndex) => (
                                                        <div key={groupIndex}>

                                                            <div className="card-header border d-flex justify-content-between align-items-center" style={{ background: '#EFEFEF' }}>
                                                                <strong>{title}</strong>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="me-2 text-muted fw-bold">
                                                                        <div className="position-relative" style={{ width: 40, height: 40 }}>
                                                                            <svg viewBox="0 0 36 36" className="circular-chart green" style={{ width: 40, height: 40 }}>
                                                                                <path
                                                                                    className="circle-bg"
                                                                                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                                                                    fill="none"
                                                                                    stroke="#d6d6d6"
                                                                                    strokeWidth="3"
                                                                                />
                                                                                <path
                                                                                    className="circle"
                                                                                    strokeDasharray={`${compliancePercent}, 100`}
                                                                                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                                                                    fill="none"
                                                                                    stroke="#23A298"
                                                                                    strokeWidth="3"
                                                                                />
                                                                            </svg>
                                                                            <span className="position-absolute top-50 start-50 translate-middle" style={{ fontSize: "0.65rem" }}>
                                                                               {compliancePercent}%
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <span className="fw-semibold text-decoration-underline">Completed</span>
                                                                </div>
                                                            </div>

                                                            <div className="px-3">
                                                                {uploadDocs.map((uploadDoc, docIndex) => {
                                                                    return (
                                                                        <div key={docIndex}>
                                                                            <div className='d-flex justify-content-between align-items-center my-2'>
                                                                                <p className="mt-2 mb-1">  <p className="font-weight-600 text-capitalize mb-0">
                                                                                    {uploadDoc.doc_type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                                                                </p></p>
                                                                                <p className='mb-0'><a href='javascript:void(0)' onClick={() => openVideoModal(compliance.compliance_id, compliance.compliance_title, uploadDoc.title, uploadDoc.doc_type)} className='mt-3' style={{ color: '#23A298', textDecoration: 'none' }}><img src='/images/add-circle.svg' alt='Add' className='me-1' />Add</a></p>
                                                                            </div>


                                                                            {uploadDoc.documents.map((doc, fileIndex) => (
                                                                                <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                                                                    <img
                                                                                        src={
                                                                                            doc.file_type === "pdf"
                                                                                                ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                                                                : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                                                        }
                                                                                        alt={doc.file_type}
                                                                                        width="25"
                                                                                        className="me-2 py-1"
                                                                                    />
                                                                                    <div className="flex-grow-1">{doc.file_name}</div>

                                                                                    <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                                                                        <img src="/images/download-icon.svg" alt="Download all" />
                                                                                    </a>

                                                                                    <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                                                                    }}>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                                                            <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                                                                        </svg>
                                                                                    </a>
                                                                                </div>
                                                                            ))}

                                                                        </div>
                                                                    );
                                                                })}

                                                            </div>
                                                        </div>
                                                    ))}
                                                    <p className="mt-4 mb-0 mx-4 text-muted small">
                                                        {complianceCategory.templateTitle}{" "}
                                                        <a
                                                            href={`/template_library/${complianceCategory.category}`}
                                                            className="text-primary text-decoration-underline"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Template Library <img src="/images/arrow-icon.svg" alt="External Link" className='ms-1' width="10" />
                                                        </a>
                                                    </p>
                                                </div>
                                            );
                                        });
                                    })()}
                                    <Modal
                                        isOpen={isModalOpen}
                                        onRequestClose={closeVideoModal}
                                        contentLabel="Upload Documents Modal"
                                        className='bg-white border-radius-20 w-25 p-4'
                                    >
 
                                        <div className="text-center mb-2 border-bottom">
                                            <h5 className="font-26 fw-bold mb-3">Upload Documents</h5>
                                        </div>
                                        <div className="modal-body text-center mt-3 px-0">
                                            <p className="font-16 text-gray  mt-1 mb-0">Supported formats include Doc, Pdf, Png</p>
                                            <p className="font-16 fw-bold mb-0">Max file size: 10MB</p>
                                            <div {...getRootProps()} className="upload-image text-center mt-4 py-5 rounded-3 mb-4 mx-2" style={{ border: "2px dashed #C7C7C7", background: "#F5F5F5" }}>
                                                <input {...getInputProps()} />
 
                                                <div className="mb-2" style={{ fontSize: "2rem", color: "#ccc" }}>
                                                    <img src="/images/upload-file-icon.svg" alt="upload-icon" style={{ maxWidth: "30px", height: "auto" }} />
                                                </div>
                                                <p className="text-muted mb-1">Drag and drop your file here
                                                    or
                                                    <a href='javascript:void(0)' className="px-1 mt-1 text-decoration-underline" style={{ color: "#146EF6" }} >
                                                        Browse
                                                    </a>
                                                </p>
                                                {selectedFiles.length > 0 && (
                                                    <p className='pt-2'>{selectedFiles.map(file => file.name).join(', ')}</p>
                                                )}
                                            </div>
 
                                            <div className="text-end">
                                                <button type="button" className="btn btn-secondary py-2 px-4 border-radius-50 font-14 me-2" onClick={closeVideoModal}>
                                                    Cancel
                                                </button>
                                                <button type="button" className="btn btn-primary py-2 px-4 font-14 border-radius-50" onClick={handleUploadDocument}>
                                                    Upload
                                                </button>
                                            </div>
                                        </div>
                                    </Modal>
                                </>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
 
export default DocumentUploadCenter;